module.exports = {"pathContext":{"name":"RepeatingEventInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"repeatInterval","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-repeating-event-input.json
// module id = 1547
// module chunks = 228473349342784